class DimensionsSection extends HTMLElement {
    constructor() {
        super();

        this.forOptionItems = this.querySelectorAll('[data-for-option]');
        this.rows = this.querySelectorAll('.dimension-row[data-is-data-row]');
        this.variantImagesJson = this.querySelector('.js-dimensions-variant-images');
        this.alternateImages = this.querySelectorAll('[data-alternate-image] .image');
        this.variantTitles = this.querySelectorAll('[data-variant-title]');
        this.variantOptions = this.dataset.productOptions.split(' / ');

        this.tabs = this.querySelectorAll('.custom-tab');
        if (this.tabs.length === 1) {
            this.classList.add('dimensions-section--single-tab');
        }

        this.addEventListener('dimension:variant:changed', this.handleVariantChanged.bind(this));

        this.updateRows();

        this.updateVariantTitles(this.variantOptions);

        try {
            this.variantImages = JSON.parse(this.variantImagesJson.textContent);
        } catch (error) {
            console.error('Error parsing variant images', error);
            this.variantImages = [];
        }
    }

    handleVariantChanged(e) {
        // Ignore variant changes that occur within product-quick-view-content
        // Check if quick view dialog is open and contains a product-section
        const quickViewDialog = document.querySelector('.product-quick-view-dialog[open]');
        if (quickViewDialog) {
            const quickViewProductSection = quickViewDialog.querySelector('.product-quick-view-content product-section');
            // If quick view is open and contains a product-section, ignore variant changes
            // (variant changes in quick view shouldn't affect main page dimensions)
            if (quickViewProductSection) {
                return;
            }
        }

        const variant = e.detail.variant,
            variantTitle = variant.title.toLowerCase();

        this.forOptionItems.forEach(item => {
            let forOption = item.dataset.forOption;
            if (variantTitle.includes(forOption)) {
                item.classList.remove('js-hide-item');
            } else {
                item.classList.add('js-hide-item');
            }
        });

        const variantThreeOptions = variant.title,
            variantTwoOptions = `${variant.options[0]} / ${variant.options[1]}`,
            variantOneOption = variant.options[0];

        const hasThreeOptionsMeta = [...this.forOptionItems].some(item => item.dataset.forOption === variantThreeOptions.toLowerCase()),
            hasTwoOptionsMeta = [...this.forOptionItems].some(item => item.dataset.forOption === variantTwoOptions.toLowerCase());

        const newVariantTitle = hasThreeOptionsMeta ? variantThreeOptions : hasTwoOptionsMeta ? variantTwoOptions : variantOneOption;

        this.variantTitles.forEach(title => {
            title.textContent = newVariantTitle;
        });


        this.updateRows();

        const activeVariantImageObj = this.variantImages.find(image => image.id === variant.id);

        if (activeVariantImageObj?.imageUrl != '') {
            this.alternateImages.forEach(imageWrapper => {
                let currentImageUrl = new URL(`https:${imageWrapper.dataset.imageUrl}`),
                    activeVariantImageUrl = new URL(`https:${activeVariantImageObj.imageUrl}`),
                    image = imageWrapper.querySelector('img');

                currentImageUrl.searchParams.delete('width');
                activeVariantImageUrl.searchParams.delete('width');

                const finalImageUrl = activeVariantImageUrl.href.replace('https:', '');

                image.src = `${finalImageUrl}&width=1920`;

                image.srcset = `
                    ${finalImageUrl}&width=100 100w, 
                    ${finalImageUrl}&width=200 200w, 
                    ${finalImageUrl}&width=300 300w, 
                    ${finalImageUrl}&width=400 400w, 
                    ${finalImageUrl}&width=500 500w, 
                    ${finalImageUrl}&width=600 600w, 
                    ${finalImageUrl}&width=700 700w, 
                    ${finalImageUrl}&width=800 800w, 
                    ${finalImageUrl}&width=900 900w, 
                    ${finalImageUrl}&width=1000 1000w,
                    ${finalImageUrl}&width=1200 1200w,
                    ${finalImageUrl}&width=1440 1440w,
                    ${finalImageUrl}&width=1920 1920w,
                `;

                imageWrapper.dataset.imageUrl = finalImageUrl;
            });
        }
    }

    updateVariantTitles(options) {
        const variantThreeOptions = options.join(' / '),
            variantTwoOptions = `${options[0]} / ${options[1]}`,
            variantOneOption = options[0];

        const hasThreeOptionsMeta = [...this.forOptionItems].some(item => item.dataset.forOption === variantThreeOptions.toLowerCase()),
            hasTwoOptionsMeta = [...this.forOptionItems].some(item => item.dataset.forOption === variantTwoOptions.toLowerCase());

        const newVariantTitle = hasThreeOptionsMeta ? variantThreeOptions : hasTwoOptionsMeta ? variantTwoOptions : variantOneOption;

        this.variantTitles.forEach(title => {
            title.textContent = newVariantTitle;
        });
    }

    updateRows() {
        this.rows.forEach(row => {
            let rowForOptions = row.querySelectorAll('.dimension-item:has([data-for-option])');

            if (rowForOptions.length === 0) {
                row.classList.add('js-hide-item');
                return;
            }

            let hasVisibleItem = false;

            rowForOptions.forEach(item => {
                let forOptions = item.querySelectorAll('.dimension-item-text');
                forOptions.forEach(option => {
                    if (!option.classList.contains('js-hide-item')) {
                        hasVisibleItem = true;
                    }
                });
            });

            if (hasVisibleItem) {
                row.classList.remove('js-hide-item');
            } else {
                row.classList.add('js-hide-item');
            }
        });
    }
}

customElements.define('dimensions-section', DimensionsSection);